import {AsyncPipe, NgFor, NgIf} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card';
import {MatIcon} from '@angular/material/icon';
import {MatList, MatListItem, MatListItemIcon} from '@angular/material/list';
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {RouterLink} from '@angular/router';
import {AuthService} from '@app/auth/auth.service';
import {StorageService} from '@app/shared/storage.service';
import {Observable} from 'rxjs';
import {take} from 'rxjs/operators';
import {FooterComponent} from '../footer/footer.component';
import {ToolbarComponent} from '../toolbar/toolbar.component';
import {TryBlockComponent} from '../try-block/try-block.component';

const PricingData = [
    {
        heading: 'Essentials',
    },
    {
        feature: 'Image Uploads',
        plans: [true, true, true],
    },
    {
        feature: 'Video Uploads',
        plans: [true, true, true],
    },
    {
        feature: 'Marmoset Uploads',
        plans: [true, true, true],
    },
    {
        feature: 'User Comments and Notifications',
        plans: [true, true, true],
    },
    {
        feature: 'Private Streams',
        plans: [false, true, true],
    },
    {
        feature: 'Unlimited Uploads',
        plans: [false, true, true],
    },
    {
        heading: 'Misc',
    },
    {
        feature: 'Asset Groups',
        plans: [true, true, true],
    },
    {
        feature: 'Responsive, Mobile Design',
        plans: [true, true, true],
    },
    {
        feature: 'Slack Integration',
        plans: [true, true, true],
    },
    {
        feature: 'Sharable Links',
        plans: [false, true, true],
    },
    {
        feature: 'Guests',
        plans: [false, false, true],
    },
    {
        feature: 'API Access',
        plans: [false, false, true],
    },
    {
        heading: 'Security',
    },
    {
        feature: 'Google Single Sign On (SSO)',
        plans: [true, true, true],
    },
    {
        feature: 'Logs',
        plans: [false, false, true],
    },
    {
        feature: 'Usage Reports',
        plans: [false, false, true],
    },
    {
        heading: 'Support',
    },
    {
        feature: 'Email support',
        plans: [true, true, true],
    },
    {
        feature: 'Discord membership',
        plans: [false, true, true],
    },
    {
        feature: 'Custom Integrations',
        plans: [false, false, true],
    },
    {
        feature: 'Training',
        plans: [false, false, true],
    },
];

@Component({
    selector: 'frog-pricing',
    templateUrl: './pricing.component.html',
    styleUrls: ['./pricing.component.scss'],
    imports: [
        ToolbarComponent,
        MatSlideToggle,
        ReactiveFormsModule,
        FormsModule,
        MatCard,
        MatCardHeader,
        MatCardTitle,
        MatCardContent,
        NgIf,
        MatButton,
        MatList,
        MatListItem,
        MatIcon,
        MatListItemIcon,
        RouterLink,
        NgFor,
        TryBlockComponent,
        FooterComponent,
        AsyncPipe,
    ],
})
export class PricingComponent implements OnInit {
    public isAuthenticated$: Observable<boolean>;
    public payAnnually: boolean;
    public interval: string;
    public PricingData = PricingData;

    constructor(
        private authService: AuthService,
        private storageService: StorageService,
    ) {
        this.payAnnually = true;
    }

    ngOnInit(): void {
        this.isAuthenticated$ = this.authService.isAuthenticated().pipe(take(1));
    }

    login(signup: boolean) {
        this.storageService.set('signup', signup);
        this.authService.redirectToIdp();
    }
}
